export enum MonitoringApiEnum {
  GetTaskMonitoring = '/monitoring/x5/tasks/:recordId',
}
